import { get } from "./http.js";
import { API } from "../config/api.js";

let cache = {
  userId: null,
  eventIds: null,
  inflight: null,
};

function normalizeEventIds(res) {
  const wishlistItems = res?.wishlist || res?.data || res || {};
  const raw = wishlistItems?.eventIds || [];
  return raw.map((obj) =>
    typeof obj === "object" && obj !== null ? String(obj._id ?? obj.id ?? "") : String(obj)
  ).filter(Boolean);
}

/** One wishlist fetch per user per session — shared by all EventCards */
export async function fetchUserWishlistEventIds(userId, token) {
  if (!userId || !token) return [];

  if (cache.userId === userId && Array.isArray(cache.eventIds)) {
    return cache.eventIds;
  }
  if (cache.userId === userId && cache.inflight) {
    return cache.inflight;
  }

  cache.userId = userId;
  cache.inflight = get(`${API.wishlist.getWishlist}/${userId}`, {
    skipAuthClear: true,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      const ids = normalizeEventIds(res);
      cache.eventIds = ids;
      cache.inflight = null;
      return ids;
    })
    .catch(() => {
      cache.eventIds = [];
      cache.inflight = null;
      return [];
    });

  return cache.inflight;
}

export function invalidateWishlistCache() {
  cache = { userId: null, eventIds: null, inflight: null };
}

export function patchWishlistCache(userId, eventId, added) {
  if (!userId || !eventId || cache.userId !== userId || !Array.isArray(cache.eventIds)) {
    invalidateWishlistCache();
    return;
  }
  const id = String(eventId);
  if (added) {
    if (!cache.eventIds.includes(id)) cache.eventIds = [...cache.eventIds, id];
  } else {
    cache.eventIds = cache.eventIds.filter((x) => x !== id);
  }
}
